<div class="overlay" *ngIf="isLoading | async">
 <mat-progress-bar class="progress-bar" [color]="color" [mode]="mode" [value]="value" [bufferValue]="bufferValue"></mat-progress-bar>
</div>